export default {"src":"/_next/static/media/vision.ac59b225.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};